<template>
    <div>
        <section id="history"
            ref="container"
            :style="{height: `${years.length * 30}vh`}"
            :class="{
                loaded: loaded,
                step1: progress <= 0,
                step2: progress > 0,
                step3: progress >= 33,
                step4: progress >= 66,
                step5: progress === 100
            }">
            <div class="hill">
                <div id="phase" v-html="phase[currentLanguage]"></div>
                <div class="year-scroll-container">
                    <div class="background"></div>
                    <div class="year-bar"
                        :style="{
                            transform: `translate(-${progress.toFixed(2)}%, 0%)`,
                            width: `${years.length * 110}px`
                        }">
                        <span :class="{
                                year: true,
                                active: +y.year === +active || (i === years.length-1 && progress >= 100),
                            }"
                            v-for="(y, i) in years">
                            <span><i v-if="yearHasAward(y.year)" class="award ion-ribbon-b"></i> {{ y.year }}</span>
                        </span>
                    </div>
                </div>
                <div class="desciption" :class="{'column-2023': +active === 2023 || +active === 2024}">
                    <div class="award">
                        <i v-if="yearHasAward()" class="ion-ribbon-b"></i>
                    </div>
                    <div class="html-grid" :class="{'column-2023': +active === 2023 || +active === 2024}">
                        <div class="html" :class="{'highlight-2023': +active === 2023 || +active === 2024}"
                            v-show="+active === +ev.year"
                            v-for="ev in historyEvents"
                            v-html="ev[`title_${currentLanguage}`]"
                            :key="ev.year">
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="history-mobile" ref="container-mobile">
            <div class="html"
                :class="{ active: +active === +ev.year }"
                v-for="ev in historyEvents">
                <h3 class="year"><i v-if="ev.award" class="ion-ribbon-b"></i> {{ ev.year }}</h3>
                <div v-html="ev[`title_${currentLanguage}`]"></div>
            </div>
        </section>
    </div>
</template>

<script>

    import { uniqBy, sortBy, find } from 'lodash-es';

    export default {
        mounted() {
            window.addEventListener('scroll', this.onScroll);
            this.loaded = true;
        },
        computed: {
            currentLanguage() {
                return this.$route.params.lang || 'en';
            },
            years() {
                return uniqBy(this.historyEvents, 'year');
            },
            progress() {
                var top = this.container.top - window.innerHeight / 2;
                var progress = (top < 0 ? ~top : 0) / this.container.height * 100;
                return progress > 100 ? 100 : progress;
            },
            active() {
                var index = Math.ceil(this.progress * this.years.length / 100);
                return this.years[index-1] ? this.years[index-1].year : 0;
            },
            phase() {

                switch(true) {
                    case this.active >= 1989 && this.active < 1995:
                        return {
                            hu: '<h3>Kezdeti lépések</h3><p>„A teljesítményt nem az idő, hanem az eredmény fémjelzi.”</p>',
                            en: '<h3>Initial Steps</h3><p>"Performance is not hallmarked by time but by result.”</p>',
                            de: '<h3>Erste Schritte</h3><p>„Nicht die Zeit, sondern das Ergebnis kennzeichnet die Leistung.”</p>',
                        };
                    case this.active >= 1995 && this.active < 2002:
                        return {
                            hu: '<h3>Az ifjúság kora</h3><p>„Az elégséges minimum helyett a lehetséges maximumot nyújtjuk.”</p>',
                            en: '<h3>Age of Youth</h3><p>„Instead of giving the minimum that is sufficient we give the maximum that is possible.”</p>',
                            de: '<h3>Jugendzeit</h3><p>„Statt des genügenden Mindestmaßes bieten wir das mögliche Höchstmaß.”</p>',
                        };
                    case this.active >= 2002 && this.active < 2009:
                        return {
                            hu: '<h3>A felnőtté válás kora</h3><p>„Szenvedélyünk az alkotás.”</p>',
                            en: '<h3>Age of Adulthood</h3><p>„Creation is our passion.”</p>',
                            de: '<h3>Zeit des Erwachsenwerdens</h3><p>„Schaffen ist unsere Leidenschaft.”</p>',
                        };
                    case this.active >= 2009:
                        return {
                            hu: '<h3>A jövő kezdete</h3><p>„A jelen értéke, a jövő lehetősége.”</p>',
                            en: '<h3>The start of the future</h3><p>„The value of today is the opportunity of tomorrow.”</p>',
                            de: '<h3>Anfang der Zukunft</h3><p>„Der Wert der Gegenwart ist eine Möglichkeit für die Zukunft.”</p>',
                        };
                    default:
                        return '';
                }

            },
            historyEvents() {
                var years = [
                    {
                        title_en: '<p>Our company started off with only two employees.</p>',
                        title_hu: `<p>Két foglalkoztatottal elindul a cég.</p>`,
                        title_de: `<p>Die Firma beginnt ihre Tätigkeit mit zwei Beschäftigten.</p>`,
                        year: 1989
                    },
                    {
                        title_en: '<p>We received assignments for full scale of building design and engineering services, which enabled us to set up our specialized design teams (structural, mechanical, electrical design teams).</p>',
                        title_hu: `<p>Magasépítési generáltervezési feladatok megjelenésének köszönhetően létrehoztuk a szakági tervezési csoportjainkat (statikus, gépész, elektromos).</p>`,
                        title_de: `<p>Entstehung von Generalplaneraufgaben im Hochbau. Errichtung von Planungsgruppen für verschiedene Sparten (Statik, Mechanik, Elektrizität).</p>`,
                        year: 1989
                    },
                    {
                        title_en: '<p>We layed the foundations of our project management service, which today is a significant part of our company. and grew a high reputation in Hungary.</p>',
                        title_hu: `<p>Ekkor kezdtük el a projekt menedzsment szolgáltatásaink alapjainak lefektetését.</p>`,
                        title_de: `<p>Schaffung der Grundlagen für die Organisation des Projektmanagements</p>`,
                        year: 1989
                    },
                    {
                        title_en: '<p>We also began to establish our bridge design and engineering services.</p>',
                        title_hu: `<p>A hídtervezési tevékenységünket is elindítottuk.</p>`,
                        title_de: `<p>Beginn der Brückenplanungstätigkeit.</p>`,
                        year: 1989
                    },
                    {
                        title_en: '<p>During these five years, CÉH created stability of their position in the market, built up their company structure, and stabilised financially.</p>',
                        title_hu: `<p>Az első 5 évben sikerült a CÉH piaci-, pénzügyi-, működési stabilitásának megteremtése.</p>`,
                        title_de: `<p>Schaffung von Stabilität für die Firma CÉH in folgenden Bereichen (Markt, Finanzen, Tätigkeit).</p>`,
                        year: 1989
                    },
                    {
                        title_en: '<p>The number of CÉH employees reached 25 people</p>',
                        title_hu: `<p>25 foglalkoztatott</p>`,
                        title_de: `<p>25 Beschäftigte</p>`,
                        year: 1995
                    },
                    {
                        title_en: '<p>New divisions were added to our services: facility management and traffic architecture.</p>',
                        title_hu: `<p>Újabb ágazataink alakulnak: facility management és a közlekedés-építészet.</p>`,
                        title_de: `<p>Weitere Sparten entstehen: Facility-Management, Verkehrsarchitektur.</p>`,
                        year: 1995
                    },
                    {
                        title_en: '<p>We won the overall design and PM services of several significantly large projects.</p>',
                        title_hu: `<p>Jelentős nagy volumenű projektek tervezési és projekt menedzsment feladatait nyerjük el.</p>`,
                        title_de: `<p>Wir gewinnen Aufträge zur Projektplanung und zum Projektmanagement von Projekten von  großem Volumen.</p>`,
                        year: 1995
                    },
                    {
                        title_hu: '<p>Generáltervezői és projekt menedzseri közreműködéssel elkészült a Millenáris Park.</p>',
                        title_en: '<p>We acted as general designer and project manager in the Millenium Park project.</p>',
                        title_de: `<p>Unter unserer Mitwirkung als Generalplaner und Projektmanager wird der Millenáris Park errichtet.</p>`,
                        year: 2001
                    },
                    {
                        title_en: '<h3>“Figyelő” Magazine, Architecture Award</h3><p>Millennium Park.</p>',
                        title_hu: '<h3>“Figyelő” Építészeti díj</h3><p>Millenáris Park.</p>',
                        title_de: `<h3>Architekturpreis der Zeitschrift “Figyelő”</h3><p>Rehabilitation des Geländes des Betriebes Ganz.</h3>`,
                        award: true,
                        year: 2001
                    },
                    {
                        title_en: '<h3>European Cultural Heritage Award, Europa Nostra Foundation</h3><p>Millennium Park.</p>',
                        title_hu: '<h3>Európai Unió Kulturális Öröksége díj, Europa Nostra díj</h3><p>Millenáris Park.</p>',
                        title_de: `<h3>Europa-Nostra-Preis</h3><p>Millenáris Park.</p>`,
                        award: true,
                        year: 2002
                    },
                    {
                        title_hu: '<p>Foglalkoztatottak száma 50 fősre növekszik.</p>',
                        title_en: '<p>Number of employees and engineering partners increases to 50 people.</p>',
                        title_de: `<p>Die Anzahl der Beschäftigten und Partneren steigt auf 50 Personen.</p>`,
                        year: 2002
                    },
                    {
                        title_en: '<p>We moved into our office building (CÉH house).</p>',
                        title_hu: '<p>Beköltöztünk a saját irodaházunkba, a CÉH-házba.</p>',
                        title_de: `<p>Wir sind in unser eigenes Bürohaus, das CÉH-Haus eingezogen.</p>`,
                        year: 2003
                    },
                    {
                        title_en: '<p>We acquired land in Eastern Hungary, which enabled us to gain experience in and establish additional divisions in industrial park-, real estate-, and urban development.</p>',
                        title_hu: '<p>További új ágazatokat hozunk létre: ipari park fejlesztés, ingatlanfejlesztés, városfejlesztés.</p>',
                        title_de: `<p>Wir schaffen weitere neue Sparten: Industrieparkentwicklung, Immobilienentwicklung, Städteentwicklung.</p>`,
                        year: 2003
                    },
                    {
                        title_en: '<p>CÉH as the general designer finished the construction plan of Megyeri bridge.</p>',
                        title_hu: `<p>Elkészültek a CÉH generáltervezésében a Megyeri-híd kiviteli tervei.</p>`,
                        title_de: `<p>In der Generalplanung von CÉH wurden die Ausführungspläne der Megyeri-Brücke erstellt.</p>`,
                        year: 2004
                    },
                    {
                        title_en: '<h3>Üzlet és Siker Business Journal chose CÉH for Qualified Enterprise</h3><p>Main Award Grand Price for best SME.</h3>',
                        title_hu: `<h3>Üzlet és Siker Vállalkozási díj</h3><p>A legjobb kis- és középvállalkozásnak járó fődíj.</h3>`,
                        title_de: `<h3>Unternehmungspreis „Üzlet és Siker”</h3><p>Hauptpreis an das beste kleine und mittelständische Unternehmen.</h3>`,
                        award: true,
                        year: 2004
                    },
                    {
                        title_en: `<h3>FIABCI Prix d’Excellence Award</h3><p>Millenium Park (for architectural design and project management)</h3>`,
                        title_hu: `<h3>FIABCI Ingatlanfejlesztési Nívódíj</h3><p>Millenáris Park (tervezési és projekt menedzsment tevékenységért)</h3>`,
                        title_de: `<h3>FIABCI Prix d’Excellence für Immobilienentwicklung</h3><p>Millenáris Park (für Planungs- und Projektmanagementtätigkeit)</h3>`,
                        award: true,
                        year: 2005
                    },
                    {
                        title_en: `<p>An affiliate was founded in Romania as a first step of our international expansion.</p>`,
                        title_hu: `<p>Leányvállalatot alapítunk Romániában, ami a nemzetközi jelenlétünk kezdetét jelenti.</p>`,
                        title_de: `<p>Gründung eines Tochterunternehmens in Rumänien.</p>`,
                        year: 2005
                    },
                    {
                        title_en: '<p>The number of our employees increased to 100 people. The number of satellite firms reached 15.</p>',
                        title_hu: '<p>Foglalkoztatottak száma 100 főre nőtt. Szatellit cégek száma elérte a 15-t.</p>',
                        title_de: '<p>Die Anzahl der Beschäftigten und Partneren ins auf 100 Personen gestiegen. Die Anzahl der Satellitenfirmen hat sich auf 15 belaufen.</p>',
                        year: 2007
                    },
                    {
                        title_en: '<h3>Construction Award of Merit</h3><p>T-Mobile office building, Szerémi road (for architectural design and project management)</p>',
                        title_hu: '<h3>Építőipari Nívódíj</h3><p>T-Mobile irodaház, Szerémi út</p>',
                        title_de: '<h3>Niveaupries der Bauindustrie</h3><p>Für das Bürohaus von T-Mobile in der Szerémi Straße (für Planungs- und Projektmanagementtätigkeit).</p>',
                        award: true,
                        year: 2007
                    },
                    {
                        title_en: '<p>We reshaped the corporate structure and founded CÉH Holding.</p>',
                        title_hu: '<p>A cégcsoport fő tulajdonosaként létrehoztuk a CÉH Holding Zrt-t.</p>',
                        title_de: `<p>Als Haupteigentümer der Firmengruppe haben wir die geschlossene AG CÉH Holding gegründet.</p>`,
                        year: 2008
                    },
                    {
                        title_en: '<h3>Dénes Gábor Prize</h3><p>dr. Sándor Kisbán for innovation in structural solutions in Megyeri Bridge.</p>',
                        title_hu: '<h3>Gábor Dénes-díj (innovációért)</h3><p>dr. Kisbán Sándor (a Megyeri híd tervezéséért)</p>',
                        title_de: `<h3>Dénes-Gábor-Preis (für Innovation)</h3><p>Für Dr. Sándor Kisbán (für die Planung der Megyeri-Brücke).</p>`,
                        award: true,
                        year: 2008
                    },
                    {
                        title_en: '<h3>János Feketeházy Prize</h3><p>Design of Megyeri Bridge for Mátyás Hunyadi.</p>',
                        title_hu: '<h3>Feketeházy János-díj</h3><p>Hunyadi Mátyás (a Megyeri híd tervezéséért).</p>',
                        title_de: `<h3>János-Feketeházy-Preis</h3><p>Für Mátyás Hunyadi (für die Planung der Megyeri-Brücke).</p>`,
                        award: true,
                        year: 2008
                    },
                    {
                        title_en: '<h3>Construction Award of Merit</h3><p>Megyeri Bridge.</p>',
                        title_hu: '<h3>Építőipari Nívódíj</h3><p>Megyeri híd.</p>',
                        title_de: '<h3>Niveaupreis der Bauindustrie</h3><p>Megyeri-Brücke</p>',
                        award: true,
                        year: 2009
                    },
                    {
                        title_en: '<h3>Széchenyi Prize</h3><p>Mátyás Hunyadi and dr. Sándor Kisbán (for the design engineering work of the Megyeri Bridge)</p>',
                        title_hu: '<h3>Széchenyi-díj</h3><p>Hunyadi Mátyás és dr. Kisbán Sándor (a Megyeri híd megvalósításában végzett tervező mérnöki tevékenységéért)</p>',
                        title_de: `<h3>Széchenyi-Preis</h3><p>Für Mátyás Hunyadi und Dr. Sándor Kisbán (für ihre Planungsingenieurtätigkeit bei der Verwirklichung der Megyeri-Brücke)</p>`,
                        award: true,
                        year: 2009
                    },
                    {
                        title_en: '<p>We set up an affilate in Russia and a representation office in Azerbaijan.</p>',
                        title_hu: '<p>Fióktelepet nyitottunk Oroszországban és kirendeltséget Azerbajdzsánban.</p>',
                        title_de: `<p>Wir haben eine Filiale in Russland und eine Außenstelle in Aserbaidschan eröffnet.</p>`,
                        year: 2010
                    },
                    {
                        title_en: '<h3>Construction Award of Merit</h3><p>Specsavers lens manufacturing.</p>',
                        title_hu: '<h3>Építőipari Nívódíj</h3><p>Specsavers szemlencsegyár.</p>',
                        title_de: `<h3>Niveaupreis der Bauindustrie</h3><p>Für die Fabrik für Brillenlinsen, Specsavers.</p>`,
                        award: true,
                        year: 2010
                    },
                    {
                        title_en: '<p>We established the CÉH Healthcare group for healthcare, hospital design and engineering projects.</p>',
                        title_hu: '<p>CÉH Egészségügyi csoport létrehozása: egészségügyi létesítmények tervezése és PM.</p>',
                        title_de: `<p>Bildung einer Gruppe für Gesundheitswesen bei der Firma CÉH: Einrichtungen des Gesundheitswesens.</p>`,
                        year: 2010
                    },
                    {
                        title_en: '<p>CÉH International Ltd was founded to ensure the uniform management of our international operations.</p>',
                        title_hu: '<p>A külföldi tevékenység összehangolása érdekében megalapítottuk a CÉH International Zrt-t.</p>',
                        title_de: `<p>Zur Abstimmung der Tätigkeiten im Ausland haben wir die geschlossene AG CÉH International gegründet.</p>`,
                        year: 2011
                    },
                    {
                        title_en: '<p>For creative project generation and development a dedicated department was established.</p>',
                        title_hu: '<p>Kreatív projekt generálásra és fejlesztésre külön irodát hoztunk létre.</p>',
                        title_de: `<p>Generierung von kreativen Projekten, Einrichtung eines gesonderten Büros für die Entwicklung.</p>`,
                        year: 2011
                    },
                    {
                        title_en: '<h3>FIABCI Prix d’Excellence Award - Special Award</h3><p>Mercedes Benz car manufacturing, Kecskemét.</p>',
                        title_hu: '<h3>FIABCI Ingatlanfejlesztési Nívódíj - különdíj</h3><p>Mercedes Benz Autógyár, Kecskemét.</p>',
                        title_de: `<h3>FIABCI Prix d’Excellence, Niveaupreis</h3><p>Für Immobilienentwicklung, Sonderpreis für das Mercedes-Benz Werk Kecskemét.</p>`,
                        award: true,
                        year: 2012
                    },
                    {
                        title_en: '<p>New service: the use of LEED and BREEAM rating systems and consultancy.</p>',
                        title_hu: '<p>Új szolgáltatásunk a LEED és a BREEAM minősítési rendszerek alkalmazásával létesítmények minősítése.</p>',
                        title_de: `<p>Wir schaffen die Möglichkeit für die Anwendung der Zertifizierungssysteme LEED und BREEAM.</p>`,
                        year: 2012
                    },
                    {
                        title_en: '<h3>Construction Award of Merit</h3><p>Mercedes-Benz Manufacturing Hungary Kft. car manufacuring, Kecskemét</h3>',
                        title_hu: '<h3>Építőipari Nívódíj</h3><p>Mercedes Benz Autógyár, Kecskemét</h3>',
                        title_de: '<h3>Niveaupreis der Bauindustrie</h3><p>Mercedes-Benz Werk, Kecskemét</h3>',
                        award: true,
                        year: 2013
                    },
                    {
                        title_en: '<h3>Construction Award of Merit</h3><p>Skanska GreenHouse office building</h3>',
                        title_hu: '<h3>Építőipari Nívódíj</h3><p>Skanska GreenHouse Irodaház</h3>',
                        title_de: '<h3>Niveaupreis der Bauindustrie</h3><p>Bürohaus GreenHouse, Skanska</h3>',
                        award: true,
                        year: 2013
                    },
                    {
                        title_en: '<p>Number of employees and engineering partners increased to 200 people.</p>',
                        title_hu: '<p>200 foglalkoztatott.</p>',
                        title_de: '<p>200 Beschäftigte und Partneren.</p>',
                        year: 2015
                    },
                    {
                        title_en: '<p>New technologies are applied to support our services: 3D scanner, 3D printer, drone filming.</p>',
                        title_hu: '<p>Új technológiai fejlesztések használata: 3D szkenner, 3D nyomtató, drón reptetés</p>',
                        title_de: '<p>Anwendung neuer technologischer Entwicklungen: 3D-Scanner, 3D-Drucker, Drohnenflüge</p>',
                        year: 2015
                    },
                    {
                        title_en: '<p>Implemented the BIM method to our engineering and PM services.</p>',
                        title_hu: '<p>BIM és GIS szolgáltatások bevezetése.</p>',
                        title_de: '<p>Einführung der Dienstleistungen BIM und GIS</p>',
                        year: 2015
                    },
                    {
                        title_en: '<p>Hódmezővásárhely Bridge was built, and is the largest roundabout overpass in Hungary.</p>',
                        title_hu: '<p>Hódmezővásárhelyi körhíd, mint az ország legnagyobb körforgalmi felüljárója átadása.</p>',
                        title_de: '<p>Übergabe der Kreisbrücke in Hódmezővásárhely, die größte kreisförmige Überführung in Ungarn.</p>',
                        year: 2017
                    },
                    {
                        title_hu: '<p>Munkavédelem és EHS (Environmental Health & Safety)  szolgáltatások bevezetése.</p>',
                        title_en: '<p>Introduced our EHS (Environmental Health & Safety) services.</p>',
                        title_de: '<p>Einführung von EHS Services  (Environmental Health and Safety).</p>',
                        year: 2018
                    },
                    {
                        title_hu: '<h3>Év hídja Díj - Megyeri híd</h3> <p>A Hidászokért Egyesület és a Közlekedéstudományi Egyesület közösen alapított díja.</p>',
                        title_en: '<h3>Megyeri Bridge was elected as the "Bridge of the Year" by the Association for Hungarian Bridge Engineers and the Hungarian Transportation Science Association.</h3>',
                        title_de: '<h3>„Brücke des Jahres” Preis - Megyeri Brücke Gemeinsam gegründeter Preis vom Brückenbauverein und vom Verein für Verkehrswissenschaft.</h3>',
                        year: 2018
                    },
                    {
                        title_en: `<h3>Construction Award of Merit</h3><p>Apollo Tyres Factory, Gyöngyöshalász</p>`,
                        title_hu: `<h3>Építőipari Nívódíj</h3><p>Apollo Tyres Gumiabroncsgyár, Gyöngyöshalász</p>`,
                        title_de: `<h3>Niveaupreis der Bauindustrie</h3><p>Reifenfabrik  Apollo Tyres, Gyöngyöshalász</p>`,
                        award: true,
                        year: 2018
                    },
                    {
                        title_en: '<h3>Disability-Friendly Workplace Award by Salva Vita Foundation</h3>',
                        title_hu: '<h3>Fogyatékosság-barát Munkahely Díj, Salva Vita Alapítvány által</h3>',
                        title_de: '<h3>Auszeichnung für behindertengerechte Arbeitsplätze von der Salva Vita Stiftung</h3>',
                        award: true,
                        year: 2018
                    },
                    {
                        title_en: '<h3>FIABCI Real Estate Development Award – Education category 1st place</h3><p>Expansion of the German School in Budapest</p>',
                        title_hu: '<h3>FIABCI Ingatlanfejlesztési Nívódíj - Oktatási kategória I. helyezett</h3><p>Budapesti Német Iskola bővítése</p>',
                        title_de: '<h3>FIABCI Real Estate Development Award - Kategorie Bildung 1. Platz</h3><p>Erweiterung der Deutschen Schule in Budapest</p>',
                        award: true,
                        year: 2019
                    },
                    {
                        title_en: '<h3>BIM ISO 19650-1 and -2:2018</h3><p>Obtaining certification of British Standars Institution, covering all business units</p>',
                        title_hu: '<h3>BIM ISO 19650-1 és -2:2018</h3><p>Minden üzletágra kiterjedő minősítés megszerzése a British Standard Institutiontől</p>',
                        title_de: '<h3>BIM ISO 19650-1 und -2:2018</h3><p>Erhalt der Zertifizierung der British Standards Institution, die alle Geschäftsbereiche abdeckt</p>',
                        year: 2020
                    },
                    {
                        title_en: '<h3>FIABCI Real Estate Development Award – 2nd place and Education category 1st place</h3><p>Moholy-Nagy University of Art and Design Campus Development, establishment of Creative Innovation Center and Knowledge Park</p>',
                        title_hu: '<h3>FIABCI Ingatlanfejlesztési Nívódíj – II. helyezett és Oktatási kategóriában I. helyezett</h3><p>Moholy-Nagy Művészeti Egyetem Campusfejlesztés Kreatív Innovációs Központ és Tudáspark kialakítása</p>',
                        title_de: '<h3>FIABCI Real Estate Development Award – 2. Platz und Kategorie Bildung 1. Platz</h3><p>Campusentwicklung der Moholy-Nagy University of Art and Design, Einrichtung des Creative Innovation Centers und des Wissensparks</p>',
                        award: true,
                        year: 2020
                    },
                    {
                        title_en: '<p>Moving back to the renovated CÉH House</p>',
                        title_hu: '<p>Visszaköltöztünk a felújított CÉH Házba.</p>',
                        title_de: '<p>Umzug zurück ins renovierte CÉH Haus</p>',
                        year: 2020
                    },
                    {
                        title_en: '<h3>BIM ISO Kitemark</h3><p>Obtaining the highest rating certification of the British Standars Institution, uniquely in the CEE region</p>',
                        title_hu: '<h3>BIM ISO Kitemark</h3><p>Közép- és Kelet-Európában egyedülálló, a British Standard Institution lehető legmagasabb minősítésének megszerzése</p>',
                        title_de: '<h3>BIM ISO Kitemark</h3><p>Erhalt der höchsten Bewertungszertifizierung der British Standards Institution, einzigartig in der CEE-Region</p>',
                        year: 2021
                    },
                    {
                        title_en: '<h3>FIABCI Real Estate Development Award - Transport facilities category 1st place</h3><p>Budafok Tramyard</p>',
                        title_hu: '<h3>FIABCI Ingatlanfejlesztési Nívódíj – I. helyezett közlekedési létesítmény kategóriájában</h3><p>Budafok kocsiszín</p>',
                        title_de: '<h3>FIABCI Real Estate Development Award – Kategorie Transportanlagen 1.</h3><p>PlatzBudafok Tramyard</p>',
                        award: true,
                        year: 2021
                    },
                    {
                        title_en: '<h3>XXIV. FIABCI Hungary – 1st place in residental building category</h3><p>Budapest, Jász Street 72</p>',
                        title_hu: '<h3>XXIV. FIABCI Ingatlanfejlesztési Nívódíj – I. helyezett lakóépület kategóriában</h3><p>Jász utca 72.</p>',
                        title_de: '<h3>XXIV. FIABCI Hungary - 1. Platz in der Kategorie Wohngebäude</h3><p>Budapest, Jász Straße 72.</p>',
                        award: true,
                        year: 2022
                    },
                    {
                        title_en: '<h3>Construction Industry Award for Excellence – 1st place in public building / commercial building category</h3><p>Budapest, Matild Palace (Southern Clotilde Palace)</p>',
                        title_hu: '<h3>Építőipari Nívódíj – I. helyezett középület / kereskedelmi kategóriában</h3><p>Matild Palace (Déli Klotild Palota)</p>',
                        title_de: '<h3>Niveaupreis der Bauindustrie – 1. Platz als öffentliches Gebäude / in Handelskategorie</h3><p>Budapest, Matild Palace (Süd-Palast Klotild)</p>',
                        award: true,
                        year: 2022
                    },
                    {
                        title_en: '<p>MOL Campus - Hungary\'s tallest office building was handed over</p>',
                        title_hu: '<p>MOL Campus – Magyarország legmagasabb épületének átadása</p>',
                        title_de: '<p>MOL Campus – Die Übergabe des höchsten Gebäudes in Ungarn</p>',
                        year: 2022
                    },              
                    {
                        title_en: '<h3>Hungarian State Opera House:</h3><p>1st place in the overall competition of the categories</p><p>1st place in the category of culture and heritage protection</p><p>1st place in the category of culture and heritage protection</p>',
                        title_hu: '<h3>Magyar Állami Operaház:</h3><p>A kategóriák összesített versenyében I. helyezett</p><p>Pályázók szavazata alapján I. helyezett</p><p>Művelődés, örökségvédelem kategória I. helyezett</p>',
                        title_de: '<h3>Ungarische Staatsoper:</h3><p>Erster Platz im Gesamtwettbewerb der Kategorien</p><p>Erster Platz in der Kategorie „Kultur und Denkmalschutz“</p><p>Erster Platz in der Kategorie „Kultur und Denkmalschutz“</p>',
                        year: 2023
                    },
                    {
                        title_en: '<h3>MOL Campus</h3><p>Third place in the overall category</p><p>First place in the Office Building category</p>',
                        title_hu: '<h3>MOL Campus</h3><p>A kategóriák összesített versenyében III. helyezett</p><p>Irodaház kategória I. helyezett</p>',
                        title_de: '<h3>MOL Campus</h3><p>Dritter Platz in der Gesamtkategorie</p><p>Erster Platz in der Kategorie Bürogebäude</p>',
                        year: 2023
                    },
                    {
                        title_en: '<h3>Matild Palace - Luxury Collection Hotel</h3><p>II place in the overall category competition</p><p>III place by vote of the applicants</p><p>Hotel category 1st place</p>',
                        title_hu: '<h3>Matild Palace - Luxury Collection Hotel</h3><p>A kategóriák összesített versenyében II. helyezett</p><p>Pályázók szavazata alapján III. helyezett</p><p>Szálloda kategória I. helyezett</p>',
                        title_de: '<h3>Matild Palace - Luxury Collection Hotel</h3><p>Zweitplatzierter in der Gesamtkategorie</p><p>Zweitplatzierter in der Gesamtkategorie</p><p>Zweitplatzierter in der Kategorie Hotel</p><p>Zweitplatzierter in der Gesamtkategorie</p>',
                        year: 2023
                    },     
                    {
                        title_en: '<h3>Eiffel Workshop of the Hungarian State Opera House</h3><p>Industrial category 1st place</p>',
                        title_hu: '<h3>Magyar Állami Operaház Eiffel Műhelyháza</h3><p>Ipari kategória I. helyezett</p>',
                        title_de: '<h3>Eiffel-Workshop-Haus der ungarischen Staatsoper</h3><p>Ich belegte den 1. Platz in der Kategorie „Paare“</p>',
                        year: 2023
                    },
                    {
                        title_en: '<h3>Tatabánya Multifunctional Sports Hall</h3><p>Public buildings / sports and leisure category Award for Excellence</p>',
                        title_hu: '<h3>Tatabányai Multifunkcionális Sportcsarnok</h3><p>Középület / sport és szabadidős építmény kategória Nívódíj</p>',
                        title_de: '<h3>Multifunktionale Sporthalle in Tatabánya</h3><p>Öffentliche Gebäude / Sport- und Freizeitgebäude Kategorie Award for Excellence</p>',
                        year: 2023
                    },
                    {
                        title_en: '<h3>Bosch Campus</h3><p>Excellence Award - Industrial and Energy Building /R&D/ category</p>',
                        title_hu: '<h3>Bosch Campus</h3><p>Nívódíj - Ipari és energetikai építmény /K+F/ kategória</p>',
                        title_de: '<h3>Bosch Campus</h3><p>Nominierungspreis - Kategorie Industrie- und Energiegebäude /R&D/</p>',
                        award: true,
                        year: 2023
                    },
                    {
                        title_en: '<h3>Hard Rock Hotel Budapest</h3><p>Award of Excellence - Public buildings / commercial and catering category</p>',
                        title_hu: '<h3>Hard Rock Hotel Budapest</h3><p>Nívódíj - Középület / kereskedelmi és vendéglátó építmény kategória</p>',
                        title_de: '<h3>Hard Rock Hotel Budapest</h3><p>Nominierungspreis - Öffentliches Gebäude / Kategorie Gewerbe und Gastgewerbe</p>',
                        award: true,
                        year: 2023
                    },
                    {
                        title_en: '<h3>Attila Tóth - Certificate of recognition ÉKM</h3>',
                        title_hu: '<h3>Tóth Attila - Elismerő oklevél ÉKM</h3>',
                        title_de: '<h3>Attila Tóth - Anerkennungsurkunde der ÉKM</h3>',
                        year: 2023
                    },
                    {
                        title_en: '<h3>Sabolcs Riesz - Ödön Lechner Award</h3>',
                        title_hu: '<h3>Riesz Szabolcs - Lechner Ödön Award</h3>',
                        title_de: '<h3>Sabolcs Riesz - Ödön Lechner Preis</h3>',
                        award: true,
                        year: 2023
                    },
                    {
                        title_en: '<h3>Best Managed Companies - Deloitte</h3><p>Excellent Managed Companies</p></h3>',
                        title_hu: '<h3>Best Managed Companies - Deloitte</h3><p>Kiválóan vezetett vállalatok</p>',
                        title_de: '<h3>Beste verwaltete Unternehmen - Deloitte</h3><p>Exzellent verwaltete Unternehmen</p>',
                        year: 2023
                    },
                    {
                        title_en: '<h3>XXV FIABCI FIBCI Real Estate Development Challenge Award</h3>',
                        title_hu: '<h3>XXV. FIABCI FIBCI Ingatlanfejlesztési Nívódíj</h3>',
                        title_de: '<h3>XXV FIABCI FIBCI Real Estate Development Challenge Award</h3>',
                        award: true,
                        year: 2023
                    },
                    {
                        title_en: '<h3>XXV. FIABCI World Prix d’Excellence 2024:</h3>',
                        title_hu: '<h3>XXV. FIABCI World Prix d’Excellence 2024:</h3>',
                        title_de: '<h3>XXV. FIABCI World Prix d’Excellence 2024:</h3>',
                        year: 2024
                    },
                    {
                        title_en: '<h3>Mol Campus</h3><p>1st place in the environmentally responsible construction category</p><p>1st place in the office building category</p>',
                        title_hu: '<h3>Mol Campus</h3><p>1. helyezett környezettudatos  építés kategória</p><p>1. helyezett irodaház kategória</p>',
                        title_de: '<h3>Mol Campus</h3><p>1. Platz in der Kategorie umweltgerechtes Bauen</p><p>1. Platz in der Kategorie Bürogebäude</p>',
                        year: 2024
                    },

                    // New
                    {
                        title_en: '<h3>Renovation of the Széchenyi Chain Bridge</h3><p>Construction Excellence Award</p>',
                        title_hu: '<h3>Széchenyi Lánchíd felújítása</h3><p>1st place in the environmentally responsible construction category</p><p>1st place in the office building category</p>',
                        title_de: '<h3>Renovierung der Széchenyi-Kettenbrücke</h3><p>Auszeichnung für herausragende Bauleistungen</p>',
                        award: true,
                        year: 2024
                    },
                    {
                        title_en: '<h3>Renovation of Hungarian State Opera House</h3><p>1st place in the environmentally responsible construction category</p><p>1st place in the office building category</p>',
                        title_hu: '<h3>Magyar Állami Operaház</h3><p>Certificate of recognition from the Construction Master Award Foundation</p>',
                        title_de: '<h3>Renovierung der Ungarischen Staatsoper</h3><p>Anerkennungsurkunde der Construction Master Award Foundation</p>',
                        award: true,
                        year: 2024
                    },
                    {
                        title_en: '<h3>NMHH Office Building EMC Measurement Laboratory and Data Center</h3><p>Construction Excellence Award</p>',
                        title_hu: '<h3>NMHH irodaépület, EMC mérőlaboratórium és a szerverközpont</h3><p>Építőipari Nívódíj</p>',
                        title_de: '<h3>NMHH Bürogebäude, EMC Messlabor und Rechnenzentrum</h3><p>Auszeichnung für herausragende Bauleistungen</p>',
                        award: true,
                        year: 2024
                    },
                    {
                        title_en: '<h3>Móricz Student Living Student Hostel</h3><p>Residential Project of the Year Award</p>',
                        title_hu: '<h3>Móricz Student Living diákszálló</h3><p>Év lakóprojektje díj</p>',
                        title_de: '<h3>Móricz Student Living Studentenwohnheim</h3><p>Auszeichnung für das Wohnbauprojekt des Jahres</p>',
                        award: true,
                        year: 2024
                    },
                    {
                        title_en: '<h3>CTP logistics center</h3><p>Best Warehouse Development of the Year</p>',
                        title_hu: '<h3>CTP logisztikai központja</h3><p>Év legjobb raktárfejlesztése díj</p>',
                        title_de: '<h3>CTP-Logistikzentrum</h3><p>Beste Lagerentwicklung des Jahres</p>',
                        award: true,
                        year: 2024
                    },
                    {
                        title_en: '<h3>Best Managed Companies, Hungary</h3><p>Deloitte</p>',
                        title_hu: '<h3>Kiválóan Vezetett Vállalatok Magyarország 2024</h3><p>Deloitte</p>',
                        title_de: '<h3>Am besten geführte Unternehmen, Ungarn</h3><p>Deloitte</p>',
                        award: true,
                        year: 2024
                    },
                    {
                        title_en: '<h3>DreamJobs</h3><p>Lovable Workplaces Award 2024</p>',
                        title_hu: '<h3>DreamJobs</h3><p>Szerethető Munkahely Díj</p>',
                        title_de: '<h3>DreamJobs</h3><p>Preis für liebenswerte Arbeitsplätze 2024</p>',
                        award: true,
                        year: 2024
                    },

                ];

                return sortBy(years, 'year');
            }
        },
        methods: {
            onScroll(event) {
                this.container = this.$refs.container.getBoundingClientRect();
            },
            yearHasAward(_year) {
                var year = _year ? _year : this.active;
                return find(this.historyEvents, { year: year, award: true });
            }
        },
        data() {
            return {
                container: {},
                loaded: false,
                year: 2009
            }
        }

    }
</script>
<style lang="scss">

    @import './../../../sass/variables';

    #phase {
        position: absolute;
        margin-top: -50vh;
        z-index: 1000;
        left: 50px;
        top: 50px;

        @media screen and (max-width: $desktop-max) {
            top: 100px;
        }

        h3 {
            font-size: 3rem;
            color: $blue;
        }

        p {
            color: lighten(#000, 30%);
            font-style: italic;
            font-size: 1.5rem;
        }
    }
    #history .desciption.column-2023 {
        h3,
        p{
            padding-right:10px;
        }
    }

    #history .desciption {
        .html {
            position: relative;
            padding-top: 10px;
            margin-bottom: -10px;

            &:after {
                background-color: $light-blue;
                background-image: linear-gradient(to right, $blue 0%, $light-blue 100%);
                border-radius: 2px;
                position: absolute;
                display: block;
                content: '';
                height: 2px;
                width: 100px;
                top: 100%;
                right: 0;
            }
        }      

        h3 {
            margin-bottom: 3px;
            line-height: 1.3;
            font-size: 22px;
            color: #fff;
        }

        p {
            line-height: 1.3;
            font-size: 16px;
            color: #fff;
        }

        span,
        * {
            color: #fff;
        }

    }
</style>
<style lang="scss" scoped>

    @import './../../../sass/variables';

    #history-mobile {
        display: none;

        @media screen and (max-width: $tablet-max) {
            display: block;
        }

        h3.year {
            font-weight: bold;

            i {
                color: $yellow;
            }
        }

        .html {
            padding: 15px;

            &:nth-child(odd) {
                background-color: lighten(#000, 95%);
            }
        }
    }
    .desciption{
        display: flex;
        flex-direction: column;
    }

    .award {
        margin-bottom: 10px;
}

.html.highlight-2023, .html.highlight-2024 {
    margin-top: -7px;
}

.html-grid {
    display: grid;
    gap: 20px;
}

.html-grid.column-2023 {
    grid-template-columns: 1fr;
    overflow-y: auto;
    gap: 20px;
    grid-template-columns: 1fr;
    max-height: 40vh;
    padding-bottom: 20px;
}

#history {
    transition: opacity 200ms;
    margin-bottom: 50vh;
    position: relative;
    margin-top: 25vh;
    display: block;
    opacity: 0;

    @media screen and (max-width: $tablet-max) {
        display: none;
    }

    &.loaded {
        transition: opacity 200ms;
        opacity: 1;
    }
}

.hill {
    background-color: $blue;
    position: relative;

    @media screen and (min-width: $tablet) {
        min-height: 250px;
        height: 50vh;
    }

    &:after {
        transform: rotate(-5deg);
        background-color: $blue;
        transform-origin: 0% 0%;
        position: absolute;
        display: block;
        z-index: 998;
        height: 9vw;
        content: '';
        width: 110%;
        left: -5%;
        top: 100%;
    }

    .step2 & {
        transform: translate(-50%, 0%);
        position: fixed;
        width: 100%;
        left: 50%;
        top: 50%;
    }

    .step5 & {
        transform: translate(0%, 0%);
        position: absolute;
        top: 100%;
        left: 0;
    }

    p,
    span {
        color: #fff;
    }

    .year-scroll-container {

        @media screen and (min-width: $tablet) {
            transform: translate(0, -100%) rotate(-15deg);
            transform-origin: 50% 100%;
            background-color: #fff;
            position: absolute;
            width: 100%;
            left: 0;
            top: 0;
        }

        &:after {
            border-color: transparent transparent $blue transparent;
            border-style: solid;
            border-width: 10px;
            position: absolute;
            margin-left: -10px;
            display: block;
            bottom: -1px;
            z-index: 20;
            content: '';
            height: 0;
            left: 50%;
            width: 0;
        }

        .background {

            @media screen and (min-width: $tablet) {
                background-color: $blue;
                position: absolute;
                height: 13vw;
                width: 100%;
                z-index: 1;
                top: 100%;
                left: 50%;
            }

            &:after {
                background-color: #fff;
                position: absolute;
                display: block;
                height: 100%;
                content: '';
                width: 100%;
                left: -100%;
                top: -100%;
            }
        }
    }

        .year-bar {

            @media screen and (min-width: $tablet) {
                transform: translate(0, 0%);
                position: relative;
                display: flex;
                z-index: 2;
                left: 50%;
            }

            .year {
                padding: 50px 0 10px;
                text-align: center;
                font-size: 40px;
                width: 110px;

                span {
                    transform-origin: 50% 50%;
                    transition: all 300ms;
                    transform: scale(0.5);
                    position: relative;
                    display: block;
                    color: $black;
                }

                .award {
                    margin-left: -24px;
                    text-align: center;
                    position: absolute;
                    font-size: 60px;
                    display: block;
                    bottom: 100%;
                    width: 40px;
                    color: gold;
                    left: 50%;
                }

                &.active span {
                    transition: all 300ms;
                    transform: scale(1);
                    font-weight: bold;

                }
            }
        }

    .desciption {

        @media screen and (min-width: $tablet) {
            position: absolute;
            text-align: right;
            z-index: 999;
            bottom: 10%;
            color: #fff;
            width: 45%;
            right: 5%;
        }

        p,
        h3,
        span {
            color: #fff;
        }

        .award {

            @media screen and (min-width: $tablet) {
                position: absolute;
                font-size: 130px;
                padding: 0 110px;
                display: block;
                right: 100%;
                bottom: 0;
            }
        }
    }
}

</style>
